import { Link } from 'react-router-dom';

const columns = [
  {
    title: '浏览内容',
    links: [
      { label: '电影频道', to: '/category/movie' },
      { label: '电视剧频道', to: '/category/tv' },
      { label: '综艺频道', to: '/category/variety' },
      { label: '影视搜索', to: '/search' },
    ],
  },
  {
    title: '我的空间',
    links: [
      { label: '我的收藏', to: '/favorites' },
      { label: '首页推荐', to: '/' },
      { label: '关于我们', to: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 md:mt-24 bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 w-fit">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-video-fill"></i>
              </span>
              <span className="font-heading font-black text-lg text-foreground-950">丝瓜视频</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-md">
              丝瓜视频是一个聚合电影、电视剧与综艺内容的影视门户，帮助影迷快速找到想看的作品，了解剧情与主创信息，并通过收藏与筛选建立自己的片单。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="px-3 py-1.5 rounded-full bg-background-50 text-xs text-foreground-700 border border-background-200">
                演示站点
              </span>
              <span className="px-3 py-1.5 rounded-full bg-primary-50 text-xs text-primary-700">
                内容每日更新
              </span>
              <span className="px-3 py-1.5 rounded-full bg-accent-50 text-xs text-accent-800">
                多端自适应
              </span>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">
                {column.title}
              </h4>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-foreground-500 leading-relaxed">
            © 2026 丝瓜视频 · 本站所有影视作品、导演与演员信息均为虚构演示内容，仅用于页面展示，不提供真实播放入口。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span className="whitespace-nowrap">版权与内容声明</span>
            <span className="whitespace-nowrap">联系我们：contact@siguatv.demo</span>
          </div>
        </div>
      </div>
    </footer>
  );
}